export default "__VITE_ASSET__amuFOlJA__"